import { useMemo } from "react";
import { MiIcon, MiIconButton } from "@miplatform/components";
import { ICONS_WEB, OPTION_STATUS } from "@miplatform/constants";
import * as mdi from "@mdi/js";
import { Box, Collapse, TextField, useTheme } from "@mui/material";
import { MaterialCard } from "../../../../../components/MaterialCard/MaterialCard";

export function PlanMaterialOption({
  item,
  area = {},
  disableActions,
  isEditing,
  handleRemoveItemFromArea,
  handleReturnItemToPlan,
}) {
  const theme = useTheme();

  const backgroundColor = useMemo(() => {
    if (
      item?.optionStatus === OPTION_STATUS.ADDED &&
      area?.optionStatus !== OPTION_STATUS.ADDED
    ) {
      return theme.palette.green.light;
    }
    if (
      item?.optionStatus === OPTION_STATUS.REMOVED &&
      area?.optionStatus !== OPTION_STATUS.REMOVED
    ) {
      return theme.palette.red.light;
    }
    return null;
  }, [item?.optionStatus, area?.optionStatus]);

  const getStatusIcon = () => {
    const statusIcons = [];
    if (item.suppliedByBuilder) {
      statusIcons.push({ path: mdi[ICONS_WEB.ACCOUNT_HARDHAT_OUTLINE] });
    }
    if (item.fieldNote) {
      statusIcons.push({ path: mdi[ICONS_WEB.NOTE_TEXT_OUTLINE] });
    }
    return statusIcons;
  };

  const getIconButton = () => {
    if (
      item?.optionStatus === OPTION_STATUS.REMOVED &&
      area?.optionStatus !== OPTION_STATUS.REMOVED
    ) {
      return (
        <MiIconButton
          onClick={() => handleReturnItemToPlan(area, item)}
          disableRipple={false}
          disabled={disableActions}
          data-testid={`return-item-btn-${item.id}`}
        >
          <MiIcon
            path={mdi[ICONS_WEB.ARROW_U_LEFT_TOP]}
            size={1}
            color={
              !disableActions
                ? theme.palette.primary.main
                : theme.palette.grey.accent
            }
          />
        </MiIconButton>
      );
    }
    if (area?.optionStatus !== OPTION_STATUS.REMOVED) {
      return (
        <MiIconButton
          onClick={() => handleRemoveItemFromArea(area, item)}
          disableRipple={false}
          disabled={disableActions}
          data-testid={`remove-item-btn-${item.id}`}
        >
          <MiIcon
            path={mdi[ICONS_WEB.TRASH_CAN]}
            size={1}
            color={
              !disableActions
                ? theme.palette.error.main
                : theme.palette.grey.accent
            }
          />
        </MiIconButton>
      );
    }
    return null;
  };

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Collapse
        in={isEditing}
        timeout={150}
        unmountOnExit
        orientation="horizontal"
      >
        {getIconButton()}
      </Collapse>
      <MaterialCard
        item={item}
        leftAction={
          <TextField
            value={item.quantity}
            sx={{
              width: 50,
              margin: theme.spacing(2),
              background: theme.palette.white.main,
            }}
            size="small"
            disabled
          />
        }
        isRemoved={item?.optionStatus === OPTION_STATUS.REMOVED}
        isSuppliedByBuilder={item.suppliedByBuilder ?? false}
        icons={getStatusIcon()}
        customBgColor={backgroundColor}
        fieldNote={item.fieldNote}
        showPrice
      />
    </Box>
  );
}
